import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import i18next from 'i18next';
import { useMemo } from 'react';

export enum AppLanguage {
  'en-us' = 'en-us',
  'en' = 'en',
  'de' = 'de',
  // !! if you add language here, dont forget to add to @lmt/expressions/src/helpers/date-helper.ts as well!!
}
export const AppLanguages = Object.keys(AppLanguage);
const languageToCultureMap: Record<AppLanguage, string> = {
  [AppLanguage['en-us']]: 'en-US',
  [AppLanguage.en]: 'en-GB',
  [AppLanguage.de]: 'de-DE',
};

export function useLanguages(): { key: AppLanguage; label: string }[] {
  const i18next = useScopedTranslation('languages');

  return useMemo(() => {
    return AppLanguages.map((x) => ({
      key: x as AppLanguage,
      label: i18next.t(('language_' + x) as any),
    }));
  }, [i18next.i18n.language]);
}

/*
Returns one of the AppLanguage (which is the current one according to i18next)
 */
export function getCurrentLanguage(): AppLanguage {
  const language = i18next.language?.toLowerCase();

  if (language === 'en-us') return AppLanguage['en-us'];
  const twoLetters = language?.substring(0, 2);
  if (AppLanguages.includes(twoLetters)) {
    return twoLetters as AppLanguage;
  }
  return AppLanguage.en;
}

export function getCurrentCulture() {
  const language = getCurrentLanguage();
  return languageToCultureMap[language] ?? 'en-US';
}
